export default "__VITE_ASSET__BWpU3hdY__"